<app-card [isHeader]=true [title]="'add_acheteur'|translate">

    <mat-card-content>
        <mat-vertical-stepper [linear]="true" class="mat-elevation-z0">
            <mat-step [stepControl]="step1.form">
                <ng-template matStepLabel>{{
                    "general_information_acheteur" | translate
                    }}</ng-template>
                <app-add-info-generale-acheteur
                        #step1
                        (add)="onnext($event)"
                ></app-add-info-generale-acheteur>
            </mat-step>

            <mat-step [stepControl]="step2.form">
                <ng-template matStepLabel>{{
                    "info_interlocuteur_unique" | translate
                    }}</ng-template>

                <app-add-info-interlocuteur-unique
                        #step2
                        (add)="nextstep($event)"
                ></app-add-info-interlocuteur-unique>
            </mat-step>

            <mat-step>
                <ng-template matStepLabel>{{
                    "Conditions_utilisation" | translate
                    }}</ng-template>
                <div>
                    <app-innerhtml #step3
                                   [code]="commonCode.InscriptionAchteur"
                    ></app-innerhtml>
                </div>
                <div fxLayoutAlign="end end" style="padding-top:2.5% ">
                    <button (click)="submit(step1.form.getRawValue(),step2.form.value)"
                            [disabled]="step3.accept=='false'" color="primary"
                            mat-raised-button>
                        <span translate>submit_save</span>
                    </button>
                </div>
            </mat-step>
        </mat-vertical-stepper>
    </mat-card-content>
</app-card>

